<template>
  <div class="confetti-modal">
    <div class="confetti-modal-screen"></div>
    <div class="confetti-modal-body-container">
      <div class="confetti-modal-top-space"></div>
      <div class="confetti-modal-body">
        <button
          class="confetti-modal-close-icon"
          type="button"
          @click="$emit('close')"
        >
          <ConfettiIcon icon="times" />
        </button>
        <div class="confetti-modal-content-section">
          <div v-if="preTitle" class="confetti-modal-pre-title">
            {{ preTitle }}
          </div>
          <h1 v-if="title" class="confetti-modal-title">{{ title }}</h1>
          <div class="confetti-modal-content">
            <slot />
          </div>
          <div v-if="hasActionsSlot" class="confetti-modal-button-section">
            <slot name="actions" />
          </div>
        </div>
      </div>
      <div class="confetti-modal-bottom-space"></div>
    </div>
  </div>
</template>

<script>
import ConfettiIcon from "./ConfettiIcon";

export default {
  name: "ConfettiModal",
  components: { ConfettiIcon },
  props: {
    preTitle: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasActionsSlot() {
      return !!this.$slots.actions;
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.close);
    document.addEventListener("keydown", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.close);
    document.removeEventListener("keydown", this.close);
  },
  methods: {
    close(event) {
      if (event.type === "mousedown" && event.buttons === 1) {
        const modalBody = document.querySelector(".confetti-modal-body");

        if (!modalBody.contains(event.target)) {
          this.$emit("close");
        }
      } else if (event.code === "Escape") {
        this.$emit("close");
      }
    },
  },
};
</script>
